export default __webpack_public_path__ + "static/media/apple-touch-icon-114x114.364ccd35.png";